export default __webpack_public_path__ + "static/media/crayon-pointer.3ff2a8af.png";